"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MapModeInputEvents = void 0;
const tslib_1 = require("tslib");
const mobx_1 = require("mobx");
const services_1 = require("../../services");
class MapModeInputEvents {
    constructor(page) {
        this.page = page;
    }
    init() {
        this.eventContext = services_1.Services.Input.getContext();
        this.eventContext.on(this.eventContext.Code.KeyL, this.toggleLabels, {
            modifiers: {
                ctrl: true
            }
        });
    }
    toggleLabels(evt) {
        evt.event.preventDefault();
        this.page.controller.map.overlay.toggleViewTitles();
    }
    destroy() {
        if (this.eventContext != null) {
            this.eventContext.destroy();
            this.eventContext = null;
        }
    }
}
exports.MapModeInputEvents = MapModeInputEvents;
tslib_1.__decorate([
    mobx_1.action.bound
], MapModeInputEvents.prototype, "toggleLabels", null);
//# sourceMappingURL=mm.events.js.map